import React from 'react';
import { useFormikContext } from 'formik';
import { ButtonGroup, Row, Col } from 'reactstrap';
import { startCase } from 'lodash';
import { Button, CardTitle } from '@cordata/buffet';
import PropTypes from 'prop-types';

const PropertyRule = ({ rule, value = {} }) => {
  const { setFieldValue } = useFormikContext();

  const handleClick = (b) => {
    if (b === 'off') {
      setFieldValue(`propertyRules.${rule}.show`, false);
      setFieldValue(`propertyRules.${rule}.required`, false);
    } else if (b.includes('required')) {
      setFieldValue(`propertyRules.${rule}.show`, true);
      setFieldValue(`propertyRules.${rule}.required`, true);
    } else if (b === 'show') {
      setFieldValue(`propertyRules.${rule}.show`, true);
      setFieldValue(`propertyRules.${rule}.required`, false);
    }
  };

  const checkValue = (v, b) => {
    if (b === 'off') {
      return !v.show && !v.required;
    } else if (b.includes('required')) {
      return v.show && v.required;
    } else if (b === 'show') {
      return v.show && !v.required;
    }

    return false;
  };

  return (
    <Col sm={6}>
      <span className="text-primary">{startCase(rule)}</span>

      <div className="pb-3 pt-2">
        <ButtonGroup className="w-100">
          {[
            'off',
            'show',
            'show & required',
          ].map(b => (
            <Button
              type="button"
              color="tertiary"
              outline={!checkValue(value, b)}
              onClick={() => handleClick(b)}
            >
              {b}
            </Button>
          ))}
        </ButtonGroup>
      </div>
    </Col>
  );
};

PropertyRule.propTypes = {
  rule: PropTypes.string.isRequired,
  value: PropTypes.shape().isRequired,
};

const MedicalEvents = () => {
  const { values } = useFormikContext();
  return (
    <>
      <CardTitle>Property Rules</CardTitle>

      <Row form>
        {[
          'eventTime',
          'eventTimeZone',
          'facility',
          'provider',
          'status',
          'location',
          'reason',
        ].map(pr => (
          <PropertyRule
            key={pr}
            rule={pr}
            value={values.propertyRules[pr]}
          />
        ))}
      </Row>
    </>
  );
};

export default MedicalEvents;
